@if (vista; as v) {
  <section class="detalle" [class.ajustada]="pantallaAncha()">
    <!-- Resumen: estado y lo más consultado. La identidad (identificación,
         función, cliente, alta, desactivado) está en el encabezado. -->
    <app-dt-card>
      <app-dt-datos destacado>
        <app-dt-dato etiqueta="Conexión" ocultarVacio>
          <app-dt-estado
            [tono]="v.conexion.tono"
            [etiqueta]="v.conexion.etiqueta"
          />
        </app-dt-dato>
        <app-dt-dato
          etiqueta="Último reporte"
          [valor]="v.hace ? 'hace ' + v.hace : null"
        >
          @if (v.ultimoReporte) {
            <span class="dt-muted fecha">{{ v.ultimoReporte }}</span>
          }
        </app-dt-dato>
        @if (v.bateria) {
          <app-dt-dato etiqueta="Batería" [valor]="v.bateria" />
        }
      </app-dt-datos>
    </app-dt-card>

    <div class="grilla">
      <div class="columna">
        <app-dt-card titulo="Activo" icono="assistant_navigation">
          @if (v.fotos.length) {
            <div class="fotos">
              @for (foto of v.fotos; track $index) {
                <!-- Como la foto del conductor en vehículos -->
                <img
                  [src]="foto"
                  [alt]="'Foto ' + ($index + 1) + ' del activo'"
                  class="foto irx-clickeable"
                  role="button"
                  tabindex="0"
                  loading="lazy"
                  (click)="abrirFoto($index)"
                  (keydown.enter)="abrirFoto($index)"
                  title="Ver foto"
                />
              }
            </div>
            <app-image-viewer
              [images]="v.fotos"
              [index]="indiceFoto"
              (indexChange)="indiceFoto = $event"
              [isVisible]="verFotos"
              [altText]="activo?.identificacion"
              (closeViewer)="verFotos = false"
            ></app-image-viewer>
          }
          <app-dt-datos>
            <app-dt-dato etiqueta="Agrupación" [valor]="v.agrupacion" />
            @if (v.fechaAlta) {
              <app-dt-dato etiqueta="Fecha de alta" [valor]="v.fechaAlta" />
            }
            <app-dt-dato etiqueta="Estado de cuenta" [valor]="v.estadoCuenta" />
            @if (v.desactivado) {
              <app-dt-dato etiqueta="Desactivado" [valor]="v.desactivado" />
            }
          </app-dt-datos>
        </app-dt-card>

        <app-dt-card titulo="Tracker" icono="gps_fixed">
          @if (v.tracker; as t) {
            <app-dt-datos>
              <app-dt-dato etiqueta="Nombre" [valor]="t.nombre">
                @if (puedeVerTracker && t.id) {
                  <a
                    irxBotonIcono
                    tamano="mini"
                    [routerLink]="[
                      '/main/administracion/trackers/detallesTracker',
                      t.id,
                    ]"
                    tooltip="Ver detalle del tracker"
                  >
                    <mat-icon>visibility</mat-icon>
                  </a>
                }
              </app-dt-dato>
              <app-dt-dato etiqueta="Tipo" [valor]="t.tipo" />
              <app-dt-dato
                etiqueta="ID único"
                [valor]="t.uniqueId"
                mono
                copiable
              />
              @if (t.deveui) {
                <app-dt-dato
                  etiqueta="DevEUI"
                  [valor]="t.deveui"
                  mono
                  copiable
                />
              }
              <app-dt-dato
                etiqueta="Frecuencia de reporte"
                [valor]="t.frecuencia"
              />
            </app-dt-datos>
          } @else {
            <span class="dt-muted">Sin tracker asignado</span>
          }
        </app-dt-card>
      </div>

      <!-- Mapa: la última ubicación o el camino de las últimas horas. Llena
           el alto de la columna (altoMapa, ver detalle de tracker). -->
      <div class="mapa" #contenedorMapa>
        <app-map-card
          [height]="pantallaAncha() && altoMapa() ? altoMapa() + 'px' : '360px'"
          [config]="mapCardConfig"
          [loading]="loadingMapa()"
        >
          <div
            card-header-actions
            class="rangos"
            role="group"
            aria-label="Período"
          >
            @for (r of rangos; track r.valor) {
              <button
                type="button"
                class="irx-chip"
                [attr.aria-pressed]="rango === r.valor"
                (click)="elegirRango(r.valor)"
              >
                {{ r.etiqueta }}
              </button>
            }
          </div>
        </app-map-card>
      </div>
    </div>
  </section>
}
